import {API_BASE_URL} from "./constants";
import {secureFetch} from "./authService";

export function getPromoVideoFolders(query) {
    let url = API_BASE_URL + '/retail/promoVideo?';
    if (query) {
        const {companyId} = query;
        if (companyId) {
            url = url + `companyId=${companyId}`;
        }
    }

    return secureFetch(url, {
        method: 'GET',
    });
}

export function addPromoVideoFolder(folder) {
    return secureFetch(API_BASE_URL + '/retail/promoVideo/folder', {
        method: 'POST',
        body: JSON.stringify(folder)
    });
}

export function updatePromoVideoFolder(folder) {
    return secureFetch(API_BASE_URL + '/retail/promoVideo/folder', {
        method: 'PUT',
        body: JSON.stringify(folder)
    });
}

export function deletePromoVideoFolder(folderId) {
    return secureFetch(API_BASE_URL + `/retail/promoVideo/folder/${folderId}`, {
        method: 'DELETE'
    });
}

export function addPromoVideoUrl(url) {
    return secureFetch(API_BASE_URL + '/retail/promoVideo/url', {
        method: 'POST',
        body: JSON.stringify(url)
    });
}

export function updatePromoVideoUrl(url) {
    return secureFetch(API_BASE_URL + '/retail/promoVideo/url', {
        method: 'PUT',
        body: JSON.stringify(url)
    });
}

export function deletePromoVideoUrl(urlId) {
    return secureFetch(API_BASE_URL + `/retail/promoVideo/url/${urlId}`, {
        method: 'DELETE'
    });
}

export function getPromoVideoAmountInCompanies(companyNameFilter) {
    let url = API_BASE_URL + '/retail/promoVideo/amount?';
    if (companyNameFilter) {
        url = url + `companyNameFilter=${companyNameFilter}`;
    }

    return secureFetch(url, {
        method: 'GET',
    });
}


// WEBPACK FOOTER //
// ./src/helpers/promoVideoService.js